module.exports = __webpack_public_path__ + "images/external_images/svg/icons/029-network.svg";